import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { Competition } from 'src/app/_models/competition'; // Make sure this path is correct

@Component({
  selector: 'app-competition',
  templateUrl: './competition.component.html',
  styleUrls: ['./competition.component.scss']
})
export class CompetitionComponent {
  @Input() feature: any;
  @Input() competitions: Observable<Competition[]>;
  @Output() featureChange = new EventEmitter<any>();

  competitionsArray: Competition[] = [];

  ngOnInit() {
    this.competitions.subscribe((competitions) => {
      this.competitionsArray = competitions;
    });
  }

  onCompetitionChange() {
    this.featureChange.emit(this.feature);
  }
}